import axios from 'axios'
import PhysicianOptionsTransformer from '../transformers/PhysicianOptionsTransformer'

export default {
    getMatchesList(data, fields) {
        const _fields = (
            fields || [
                'id',
                'email',
                'phone',
                'firstName',
                'lastName',
                'designation',
                'userRole(id,name)',
                'specialities(speciality(id,name),subSpeciality(id,name))',
                'professionalRating',
                'rating',
                'connectionCount',
                'referralsReceivedCount',
                'isFavorited',
                'isInMyNetwork',
                'isSignupFinished',
                'practice(id,subscription,name,practiceType,locations(id,name,address,city,state,zip,latitude,longitude))',
                'avatar(thumb-360,source)',
                'physicianGroup(id,name)',
            ]
        ).join(',')

        return axios.get('/unauthenticated/referrals/matches', {
            params: { _fields, ...data },
        })
    },

    getPhysicianData({ userId, physicianId, fields }) {
        const _fields = (
            fields || [
                'id',
                'email',
                'avatar(thumb-360,source)',
                'phone',
                'firstName',
                'lastName',
                'designation',
                'userRole(id,name)',
                'specialities(speciality(id,name),subSpeciality(id,name))',
                'professionalRating',
                'rating',
                'connectionCount',
                'referralsReceivedCount',
                'isFavorited',
                'isInMyNetwork',
                'practice(id,name,practiceType,locations(id,name,address,city,state,zip,latitude,longitude))',
                'physicianGroup(id,name)',
            ]
        ).join(',')

        return axios.get(`/users/${userId}/phisician-data/${physicianId}`, { params: { _fields } })
    },

    getUserList(query, userRoleId) {
        return axios.get('users/getlist', {
            params: { query, userRoleId },
            transformResponse: [PhysicianOptionsTransformer.transform('id', 'name')],
        })
    },
}
